
import React from "react";
import { DateHelper, useSearchParams } from "@rivtn/noseur";
import { i18nManager } from "../i18n";
import PageHead from "./common/PageHead";
import EventItem from "./common/EventItem";
import Pagination from "./common/Pagination";
import FilterTags from "./common/FilterTags";
import { Utils } from "../../../../utils";
import styles from "../assets/style.module.css";
import { ApiResponseData, BaseService, IHostWebsite, IWebsiteEvent, OmneHostService, SanitizedResponse } from "../../../../services";

export interface EventsProps {
    website: IHostWebsite;
}

function Events({ website }: EventsProps) {

    const labels = i18nManager.Labels.events;
    const omnehostService = OmneHostService.getInstance();
    const [open, setOpen] = React.useState<number>(0);
    const [events, setEvents] = React.useState<ApiResponseData<IWebsiteEvent>>();
    const { page, setPage, tab, setTab } = useSearchParams({ defaultInit: window.location.search, params: { page: 1, tab: "all" } });

    React.useEffect(fetchInformation, [omnehostService, page, tab]);

    return (<>
        <PageHead tag={labels.kicker} title={labels.title} subtitle={labels.desc} />
        <section className={styles["section-page"]}>
            <div className={styles["container"]}>
                <FilterTags value={`${tab}`} onChange={setTab} options={[["all", labels.all], ["upcoming", labels.upcoming], ["live", labels.live], ["past", labels.past]]} />
                {(!!events?.content)
                    ? (events.content.length > 0
                        ? (<div className={styles["acc-list"]}>
                            {events.content.map((ev, i) => (<EventItem key={ev.external_id} index={i} event={ev} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />))}
                        </div>)
                        : Utils.emptyState())
                    : Utils.loadingState()}
                <Pagination page={parseInt(`${page}`)} rowsPerPage={events?.size} totalRecords={events?.total_elements} onPageChange={setPage} />
            </div>
        </section>
    </>);

    function fetchInformation() {
        setEvents({});
        setOpen(0);
        const now = DateHelper.now().toISOString();
        const extraParams: Record<string, string> = {};
        if (tab === "past") extraParams.end_date__lt_eq = now;
        else if (tab === "upcoming") extraParams.start_date__gt_eq = now;
        else if (tab === "live") {
            extraParams.end_date__gt_eq = now;
            extraParams.start_date__lt_eq = now;
        }
        omnehostService.queryHostEvents(website.host.external_id, {
            page,
            ...extraParams,
            sort: "updated_at,DESC",
        }).then(({ apiResponse }: SanitizedResponse<IWebsiteEvent>) => {
            setEvents(apiResponse.data!);
        }).catch(BaseService.reportError);
    }
}

export default Events;
